import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { gsap } from "../../animations/gsap.config";
import { ScrollTrigger } from "../../animations/gsap.config";
import { useApp } from "../../context/AppContext";

import Navbar from "./Navbar";
import Footer from "./Footer";
import Loader from "../common/Loader";
import CustomCursor from "../common/CustomCursor";
import ScrollProgress from "../common/ScrollProgress";
import { useQuery } from "@tanstack/react-query";
import api from "../../api/api";

const Layout = ({ children }) => {
  const { isLoading, setCompanyInfo } = useApp();
  const { pathname } = useLocation();
  const { data: companyinfo } = useQuery({
    queryKey: ["companyInfo"],
    queryFn: () => api.get("/api/companyinfo/public").then((res) => res.data),
  });
  setCompanyInfo(companyinfo);

  /* ── Scroll to top & refresh ScrollTrigger on route change ── */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    // Small delay to let new page render
    const id = setTimeout(() => ScrollTrigger.refresh(), 300);
    return () => clearTimeout(id);
  }, [pathname]);

  /* ── Page transition ── */
  useEffect(() => {
    if (isLoading) return;

    const main = document.getElementById("main-content");
    if (!main) return;

    gsap.fromTo(
      main,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power3.out", delay: 0.1 },
    );
  }, [pathname, isLoading]);

  return (
    <>
      {/* Global UI */}
      <CustomCursor />
      <ScrollProgress />
      {isLoading && <Loader />}

      {/* Site shell */}
      <div
        className="min-h-screen flex flex-col"
        style={{ visibility: isLoading ? "hidden" : "visible" }}
      >
        <Navbar companyinfo={companyinfo} />

        <main
          id="main-content"
          className="flex-1"
          style={{ paddingTop: "0" }}
          role="main"
        >
          {children}
        </main>

        <Footer companyinfo={companyinfo} />
      </div>
    </>
  );
};

export default Layout;
